export function limitedUpsellPacksLink() {
    document.addEventListener("click", (event) => {
        const link = event.target.closest(".gwc-upsell-limited-packs-link");

        if (!link) {
            return;
        }

        event.preventDefault();

        if (link.dataset.dismissPending === "true") {
            return;
        }

        const modal = link.closest('[data-gwc-upsell-modal="true"]');
        const destination = link.href;
        const productId = link.dataset.productId;
        const ajaxUrl = link.dataset.dismissUrl || window.growtype_wc_ajax?.url;

        if (!modal || !productId || !ajaxUrl || !window.jQuery) {
            return;
        }

        link.dataset.dismissPending = "true";
        link.setAttribute("aria-disabled", "true");

        const resetAfterFailure = (error) => {
            delete link.dataset.dismissPending;
            link.removeAttribute("aria-disabled");
            console.error("Growtype limited upsell: Failed to dismiss upsell", error);
        };

        // Use the same server action as Close, without requiring a particular
        // version of the plugin's modal instance to be exposed on the DOM.
        const dismissRequest = window.jQuery.ajax({
            url: ajaxUrl,
            method: "POST",
            dataType: "json",
            data: {
                action: modal.dataset.ajaxAction,
                nonce: modal.dataset.ajaxNonce || window.growtype_wc_ajax?.nonce,
                product_id: productId,
            },
        });

        if (!dismissRequest || typeof dismissRequest.done !== "function") {
            resetAfterFailure(new Error("Upsell dismissal did not start"));
            return;
        }

        dismissRequest.done((response) => {
            if (response && response.success === true) {
                window.location.assign(destination);
                return;
            }

            resetAfterFailure(response);
        }).fail(resetAfterFailure);
    });
}
